// import { method } from 'lodash';
import {
  apiDefaultWithoutToken,
  apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll,
  apiDefaultWithoutTokenWithUrlencodedType,
} from './api';

const prefix = '/_ui/responsive/theme-trplus/app/src/js/controller/Json';

// header
// 更新購物車顯示數量
export const apiGetIndexMiniCartJson = (method) => apiDefaultWithoutToken[method]('/cart/miniCartList');

// login
export const apiPostMemberLogin = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/memberLogin/login', data);

// 註冊頁面相關
// 獲取手機驗證碼
export const apiPostRegisterPhoneValiCode = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/memberMobileVerify/sendMobileVerify', data);
// 註冊會員
export const apiDoMemberRegister = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/memberRegister/doMemberRegister', data);

// 購物車-步驟二
// 獲取地址簿列表
export const apiGetAddressBook = (method) => apiDefaultWithoutToken[method]('/checkout/shopping-info/addressBooks');
// 確認結帳
export const apiPostPlaceOrder = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/checkout/info/process/placeOrder', data);

// 订单
export const apiGetOrderListDetail = (method, orderInfo) => apiDefaultWithoutToken[method](`/my-account/Brieforder/${orderInfo.ordercode}?ordersource=${orderInfo.thischanel}`);

// 使用折價卷
export const apiPostUseCouponCode = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/voucher/apply?code=${data.code}`, data.cSRFToken);
// 跳转购物商品数量
export const apiPostUpdateCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/update', data);
// cart
export const apiGetCartListData = (method, data) => apiDefaultWithoutToken[method]('/cart/cartList', data);

/** 產品頁相關 */
// 提交評價信息
export const apiPostAddWriteReview = (method, sku, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/p/${sku}/writeReview`, data);
// 加入最愛
export const apiPostAddToFavorite = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerTracking/add', data);
// 取消最愛
export const apiPostRemoveToFavorite = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerTracking/remove', data);
// 加入購物車
export const apiPostAddToCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/add', data);
// //
// export const apiPostDeleteAllBrowserProduct = (method, data) => apiDefaultWithoutToken[method]('/p/deleteBrowsedProduct', data);
// export const apiPostDeleteBrowserProduct = (method, sku) => apiDefaultWithoutToken[method]('/p/deleteBrowsedProduct', sku);
// export const apiGetSimpleProductData = (method, sku) => apiDefaultWithoutToken[method](`/rest/v2/trplus/productList?skus=${sku}`);
// export const apiGetPointOfServices = (method, sku, data) => apiDefaultWithoutToken[method](`/store-pickup/${sku}/pointOfServices`, data);
// export const apiGetCouponListForProduct = (method, sku) => apiDefaultWithoutToken[method](`/query/couponListForProduct?productCode=${sku}`);
// export const apiPostAddProductArrivalNotice = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerProductArrivalNotice/add', data);
// export const apiPostRemoveProductArrivalNotice = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerProductArrivalNotice/remove', data);

export const apiPostRefreshOrder = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/guest/refreshOrder', data);
export const apiPostGetEntryNumbers = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/guest/getEntryNumbers', data);
export const apiGetReturnOrRefund = (method, paramsData) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/guest/getReturnOrRefund?orderCode=${paramsData.orderCode}&entryNumber=${paramsData.orderEntries}`);
export const apiPostOrderReturn = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/guest/order-return', data, { timeout: 30000 });
export const apiGetReturnBankIDWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/orderBank.json`);
export const apiGetReturnRequestB2B = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/my-account/rtvStatusJson?code=${data}`, { timeout: 30000 });

// 获取可使用折扣卷
export const getCouponListJSON = (method, data) => apiDefaultWithoutToken[method](`/memberCoupon/allCouponList?page=${data.page}&type=${data.type}`, { timeout: 30000 });

// 获取验证码
export const getSentModifyPwOTP = (method, data) => apiDefaultWithoutToken[method]('/memberModify/sentModifyPwOTP', data, { timeout: 30000 });
// 提交修改密码
export const getDoMemberPasswordModify = (method, data) => apiDefaultWithoutToken[method]('/memberModify/doMemberPasswordModify', data, { timeout: 30000 });
